import {
  ApiCartChangeCartDeliveryAddressFailedAction,
  ApiCartChangeCartDeliveryAddressSucceededAction,
  apiCartChangeCartDeliveryAddressFailedType,
  apiCartChangeCartDeliveryAddressRequested,
  apiCartChangeCartDeliveryAddressSucceededType
} from '../../api/cart/changeCartDeliveryAddressApi';
import {
  ChangeCurrentCartDeliveryAddressRequestedAction,
  changeCurrentCartDeliveryAddressFailed,
  changeCurrentCartDeliveryAddressSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import { ChangeCartDeliveryAddressResult } from '../../../graphql/cart/changeCartDeliveryAddress';
import { CustomOrderType } from '../../carts/CustomOrderType';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* changeCurrentCartDeliveryAddressSaga({
  payload: { actionId: requestedActionId, address: deliveryAddress, customOrderType }
}: ChangeCurrentCartDeliveryAddressRequestedAction): Generator {
  const actionId: number = generateActionId();
  yield* put(
    apiCartChangeCartDeliveryAddressRequested({
      actionId,
      customOrderType,
      deliveryAddress,
      parentActionId: requestedActionId
    })
  );

  yield* actionsLoop(actionId, requestedActionId, customOrderType);
}

function* actionsLoop(
  actionId: number,
  requestedActionId: number,
  customOrderType: CustomOrderType
): Generator {
  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartChangeCartDeliveryAddressSucceededAction>(
        apiCartChangeCartDeliveryAddressSucceededType
      ),
      failed: take<ApiCartChangeCartDeliveryAddressFailedAction>(
        apiCartChangeCartDeliveryAddressFailedType
      )
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const result: ChangeCartDeliveryAddressResult = succeeded.payload.result;
        if (result.__typename === 'ChangeCartDeliveryAddressFailedResult') {
          yield* put(
            changeCurrentCartDeliveryAddressFailed({
              requestedActionId
            })
          );
        } else {
          yield* put(
            changeCurrentCartDeliveryAddressSucceeded({
              cart: convertCartToStateCart(result.cart),
              customOrderType,
              requestedActionId
            })
          );
        }
      } else if (failed !== undefined) {
        yield* put(
          changeCurrentCartDeliveryAddressFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default changeCurrentCartDeliveryAddressSaga;
